// src/pages/warehouse/components/RejectionList.tsx
// C-I5 (Welle W): zeigt final vom Server abgelehnte gepufferte Buchungen mit Details
// (Palette, Aktion, Code, Meldung) statt nur einer Zaehler-Toast — Pendant zu
// stahlia-scan-app/src/components/FlushRejectionWatcher.tsx (dort B-I3).
import { useEffect, useState } from 'react'
import { Button } from '@/components/ui/button'
import { getRejections, clearRejections, type MoveRejection } from '@/api/warehouse'

/** Kurzer, lesbarer Aktionsname aus dem API-Pfad (z.B. '/warehouse/move/place/' → 'place'). */
function actionFromPath(path: string): string {
  const m = /\/warehouse\/(?:move|position|events)\/([a-z-]+)\/?$/.exec(path)
  return m?.[1] ?? path
}

export function RejectionList({ refreshKey }: { refreshKey: number }) {
  const [items, setItems] = useState<MoveRejection[]>([])
  useEffect(() => { setItems(getRejections()) }, [refreshKey])
  if (items.length === 0) return null
  return (
    <div className="rounded-lg border-2 border-red-600 bg-red-50 dark:bg-red-950 p-3 space-y-2">
      <div className="flex items-center justify-between gap-2">
        <div className="font-bold text-red-700">Abgelehnt — bitte klären ({items.length})</div>
        <Button size="sm" variant="ghost" onClick={() => { clearRejections(); setItems([]) }}>Ausblenden</Button>
      </div>
      <ul className="text-xs space-y-1 max-h-40 overflow-y-auto">
        {items.map((r, i) => (
          <li key={`${r.at}-${i}`} className="font-mono">
            {r.paletteNo ?? '?'} · {actionFromPath(r.path)} · {r.code ?? '?'} — {r.message ?? ''}
          </li>
        ))}
      </ul>
    </div>
  )
}
